import './App.css';
import NavBar from './component/NavBar/NavBar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Hero from './component/Hero/hero';
import { Link } from 'react-router-dom';
import Bottom from './component/bottom/bottm';
import Start from './component/componentlist/start';
import ViewComponent from './component/livepreview/livepreview';
import Login from './component/user/Login';
import { AuthProvider } from './component/user/AuthContext';
import SignUp from './component/user/SignUp';
import TermsAndServices from './component/user/TermsAndServices';
import BasicPayment from './component/payment/BasicPayment';
import PremiumPayment from './component/payment/PremiumPayment';

function App() {
  return (
    <AuthProvider> {/* Wrap the entire Router with AuthProvider */}
      <Router>
        <div className="App">
          <NavBar />
        </div>
        <Routes>
          <Route path='/' element={<><Hero /> <Bottom /></>} />
          <Route path='*' element={<><Hero /> <Bottom /></>} />
          <Route path='/start' element={<Start />} />
          <Route path='/View/:id' element={<ViewComponent />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<SignUp />} />
          <Route path="/terms" element={<TermsAndServices />}/>
          <Route path='/Basic' element={<BasicPayment />} />
          <Route path='/Premium' element={<PremiumPayment />}/>
        </Routes>
        <hr />
        <div className="Bottom-links">
          <Link to="/terms" >terms and services</Link>
          <a>© 2024 Made by Mohammed Nael.</a>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
